(function () {
  function init() {
    const button = document.querySelector('#filter-icon-bubble');
    const header = document.querySelector('.section-header .header');
    if (!button || !header) return;

    const buttonLabel = button.querySelector('.filter-button-text');

    function open() {
      header.classList.add('header-menu-open');
      if (buttonLabel) buttonLabel.textContent = 'Close';
      button.setAttribute('aria-expanded', 'true');
      sessionStorage.setItem('jl-menu-open', '1');
    }

    function close() {
      header.classList.remove('header-menu-open');
      if (buttonLabel) buttonLabel.textContent = 'Menu';
      button.setAttribute('aria-expanded', 'false');
      sessionStorage.removeItem('jl-menu-open');
    }

    /* Sync button label and aria state with the class that the inline script may have
       already applied to <header> before first paint. Without this, the button text
       would still read "Menu" and aria-expanded would be wrong even though the menu
       visually appears open. */
    if (header.classList.contains('header-menu-open')) {
      if (buttonLabel) buttonLabel.textContent = 'Close';
      button.setAttribute('aria-expanded', 'true');
    } else {
      button.setAttribute('aria-expanded', 'false');
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();
      header.classList.contains('header-menu-open') ? close() : open();
    });

    document.addEventListener('keyup', function (e) {
      if (e.code === 'Escape' && header.classList.contains('header-menu-open')) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
